module.exports = __webpack_public_path__ + "media/images/city_img/icon8-98b8d604bf09bd6f9a1d205ed085238f.png";